package nl.volleyplanner.web.controller.planner.rulesets_config

import nl.volleyplanner.api.planner.GroupConstraint

/**
 * (dirty?) helper for constraint groups with custom groups
 * We need to find the type of groups we are using. This is not stored in the model in the backend
 * because we keep flexibility there.
 *
 * However, for the UI we don't want to provide too many options. And help by selecting a type before supported groups
 * Challenge is, custom groups can be their own type
 */
enum class GroupConstraintType(val label: String) {
    RefereeLicense("Licentie"),
    AgeGroup("Leeftijdsgroep"),
    ParentsOwnTeam("Ouders eigen team"),
    Custom("Overig");

    companion object {
        private fun fromTypeNameAndIdentifier(typeName: String, identifier: String?): GroupConstraintType {
            return when {
                typeName == "Group" -> RefereeLicense
                typeName == "AgeGroup" -> AgeGroup
                identifier == "Custom:ParentsOwnTeam" -> ParentsOwnTeam
                else -> Custom
            }
        }

        fun fromConstraintGroup(constraint: GroupConstraint) = fromTypeNameAndIdentifier(constraint.groupType, constraint.groupIdentifier)

        fun fromConstraintGroups(groupConstraints: List<GroupConstraint>) : GroupConstraintType? {
            val constraintGroupType = groupConstraints.groupingBy { it.groupType }
                .eachCount().maxByOrNull { it.value }?.key

            if (constraintGroupType == null) return null
            return fromTypeNameAndIdentifier(constraintGroupType, groupConstraints.first().groupIdentifier)
        }
    }
}